import { getAxios } from 'src/lib/axios';
import { SystemSettingQueryResponse } from '../types/SystemSettingQueryResponse';
import { useQuery } from '@tanstack/react-query';

const getSystemSetting = async (request: string): Promise<SystemSettingQueryResponse> => {
  return (await getAxios().get(`/api/onlinebookingsystemsetting?key=` + request)).data;
};

export const useSystemSettingQuery = (request: string) => {
  return useQuery({
    queryKey: ['system-setting', request],
    retry: false,
    gcTime: 0,
    queryFn: () => getSystemSetting(request)
  });
};
